import {patchState, signalStore, withMethods, withState} from "@ngrx/signals";
import {catchError, EMPTY, switchMap, tap} from "rxjs";
import {inject} from "@angular/core";
import {ContactApi, ContactSubmissionPayload} from "../../../../../core/data/contact/contact-api";
import {rxMethod} from "@ngrx/signals/rxjs-interop";
import {MatSnackBar} from "@angular/material/snack-bar";

interface ContactSubmissionState {
  isLoading: boolean;
  error: unknown | null;
  lastSubmittedAt: number | null;
}

const initialState: ContactSubmissionState = {
  isLoading: false,
  error: null,
  lastSubmittedAt: null,
};
export const ContactStore = signalStore(
  withState(initialState),
  withMethods((store, contactApi = inject(ContactApi), snackbar = inject(MatSnackBar)) => ({
    submit: rxMethod<ContactSubmissionPayload>((payload$) =>
      payload$.pipe(
        tap(() => patchState(store, {isLoading: true, error: null})),
        switchMap((payload) =>
          contactApi.submitContact({data: payload}).pipe(
            tap(() => {
                patchState(store, {
                  isLoading: false,
                  error: null,
                  lastSubmittedAt: Date.now(),
                });

                snackbar.open('Message sent successfully', 'Close', {
                  duration: 5000,
                  horizontalPosition: 'right',
                  verticalPosition: 'bottom',
                });
              }
            ),
            catchError((error) => {
              patchState(store, {
                isLoading: false,
                error,
              });

              snackbar.open('Failed to send message', 'Close', {
                duration: 5000,
                horizontalPosition: 'right',
                verticalPosition: 'bottom',
              });

              return EMPTY;
            }),
          ),
        ),
      ),
    ),
  })),
);
